import { z } from 'zod';

/** Author-owned visibility in DM and group DM. Missing preserves stored value. */
export const teamPrivacySchema = z.object({ showTeamInDms: z.boolean().optional() });
